import { stringify } from "../../util/querystring-util";
import {
  GetEnvironmentCopyRequestsRequest,
  GetEnvironmentCopyRequestsResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface DeploymentRequestsRestResource {
  getEnvironmentCopyRequests(
    request: GetEnvironmentCopyRequestsRequest,
  ): Promise<GetEnvironmentCopyRequestsResponse>;
}

const REST_RESOURCE_NAME = "/environment-copy-requests";

/**
 * GET /environment-copy-requests
 */
const getEnvironmentCopyRequests = restResourceRequester<
  GetEnvironmentCopyRequestsRequest,
  GetEnvironmentCopyRequestsResponse
>("GET", (request) => {
  return `${REST_RESOURCE_NAME}?${stringify(request)}`;
});

export const DeploymentRequestsRestResource: DeploymentRequestsRestResource = {
  getEnvironmentCopyRequests: getEnvironmentCopyRequests,
};
